module.exports = __webpack_public_path__ + "img/28.1e51fbb2.jpg";